const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export function isValidEmailOrEmpty(input) {
    if (!input) {
        return true;
    }

    if (input.trim() === "") {
        return true;
    }

    return isValidEmail(input);
}

export function isValidEmailAndNotEmpty(input) {
    if (!input) {
        return false;
    }
    if (input.trim() === "") {
        return false;
    }

    return isValidEmail(input);
}

export function isValidEmail(input) {
    if (!input) {
        return false;
    }

    return input.match(EMAIL_REGEX);
}
